import React, { useState, useEffect, useRef } from 'react'
import { 
  SkillsWrapper,
  SkillsHeader,
  SkillsContainer,
  SkillTag,
  SkillTagItems,
  Icon
 } from './styles/Skills.styles'
import { skillsData } from '../Constants'

function Skill() {
  const[hoveredIndex, setHoveredIndex] = useState(null)
  const[visibleCount, setVisibleCount] = useState(0)
  const skillRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if(entry.isIntersecting) {
        const intervalId = setInterval(() => {
          setVisibleCount(prev => {
            if (prev < skillsData.length) {
              return prev + 1;
            } else {
              clearInterval(intervalId)
              return prev
            }
          });
          
        }, 125);

      }
    }, { threshold: 0.2 });

    const current = skillRef.current;
    if (current) observer.observe(current)

    return () => {
      if (current) observer.unobserve(current)
    }
  }, [])

  return (
    <SkillsWrapper id="skills" ref={skillRef}>
      <SkillsHeader>Skills</SkillsHeader>
      <SkillsContainer>
        {skillsData.slice(0, visibleCount).map((skill, index) => (
          <SkillTag 
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            $isVisible={index < visibleCount}
          >
            <SkillTagItems>
              <Icon 
                $hoveredIndex={hoveredIndex === index} 
                style={{fontSize: '2rem', 
                color: '#2563eb', 
                transition: 'transform 0.5s ease' }} className={`${skill.icon} text-lg`} ></Icon>
              <p style={{marginTop: '10px', color: '#2563eb' }}>{skill.name}</p>
            </SkillTagItems>
          </SkillTag>
        ))}
      </SkillsContainer>
    </SkillsWrapper>
  )
}

export default Skill
